var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "log-dialog" },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": [_vm.message.reason],
            fullscreen: _vm.message.fullscreen,
            height: "80%",
            persistent: _vm.message.persistent
          },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          [
            _c(
              "div",
              {
                staticClass: "log-wrapper",
                class: [{ filter: _vm.active === 0 }]
              },
              [
                _c(
                  "v-tabs",
                  {
                    attrs: {
                      color: "cyan",
                      dark: "",
                      "slider-color": "yellow"
                    },
                    model: {
                      value: _vm.active,
                      callback: function($$v) {
                        _vm.active = $$v
                      },
                      expression: "active"
                    }
                  },
                  [
                    _vm._l(_vm.items, function(n, index) {
                      return _c(
                        "v-tab",
                        {
                          key: n.name + index,
                          attrs: { ripple: "" },
                          on: {
                            click: function($event) {
                              return _vm.tabClick(n)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " + _vm._s(n.name) + "\n\n          "
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.items, function(i, index) {
                      return _c(
                        "v-tab-item",
                        { key: i.name + index },
                        [
                          i.name === "network"
                            ? _c(
                                "v-expansion-panel",
                                [
                                  _c("i", [
                                    _c("b", [
                                      _vm._v(
                                        "Network: Success/Failure; Content: Failure only; Media: Static content - Success/Failure"
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.networkLogs.slice().reverse(),
                                    function(log) {
                                      return _c(
                                        "v-expansion-panel-content",
                                        {
                                          key: log.dynamicId,
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "header",
                                                fn: function() {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        class: [
                                                          {
                                                            "error-response":
                                                              log.response
                                                                .error ||
                                                              log.response
                                                                .message
                                                          },
                                                          {
                                                            "success-response":
                                                              log.response
                                                                .result ||
                                                              log.response
                                                                .data ||
                                                              log.response
                                                                .status === 204
                                                          }
                                                        ]
                                                      },
                                                      [
                                                        log.type === "api"
                                                          ? _c("p", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  log.request
                                                                    .url
                                                                )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        log.type === "content"
                                                          ? _c("p", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  log.response
                                                                    .url
                                                                )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        log.type === "media"
                                                          ? _c("p", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  log.request
                                                                )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "p",
                                                          {
                                                            staticStyle: {
                                                              "font-size":
                                                                "10px"
                                                            }
                                                          },
                                                          [
                                                            _c("b", [
                                                              _vm._v(
                                                                "Request time:"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  String(
                                                                    new Date(
                                                                      log.date
                                                                    ).getHours()
                                                                  ).padStart(
                                                                    2,
                                                                    "0"
                                                                  )
                                                                ) +
                                                                " : " +
                                                                _vm._s(
                                                                  String(
                                                                    new Date(
                                                                      log.date
                                                                    ).getMinutes()
                                                                  ).padStart(
                                                                    2,
                                                                    "0"
                                                                  )
                                                                ) +
                                                                " : " +
                                                                _vm._s(
                                                                  String(
                                                                    new Date(
                                                                      log.date
                                                                    ).getSeconds()
                                                                  ).padStart(
                                                                    2,
                                                                    "0"
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "v-card",
                                            [
                                              log.type === "api"
                                                ? _c("v-card-text", [
                                                    _c("p", [
                                                      _c("b", [
                                                        _vm._v("Params:")
                                                      ]),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            log.request.params
                                                          )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _c("b", [
                                                        _vm._v("Payload:")
                                                      ]),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            log.request.data
                                                          )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _c("b", [
                                                        _vm._v("IGT-Client-Id:")
                                                      ]),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            log.request.headers[
                                                              "IGT-Client-Session"
                                                            ]
                                                          )
                                                      )
                                                    ])
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              log.type === "content"
                                                ? _c("v-card-text", [
                                                    _c("p", [
                                                      _c("b", [
                                                        _vm._v("Request:")
                                                      ]),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            log.response.url
                                                          )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _c("b", [
                                                        _vm._v("Params:")
                                                      ]),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            log.response.params
                                                          )
                                                      )
                                                    ])
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              log.type === "media"
                                                ? _c("v-card-text")
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "divider-wrapper"
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass: "divider"
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-card-text", [
                                                log.response.result ||
                                                log.response.data
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "block word-break"
                                                      },
                                                      [
                                                        log.response &&
                                                        log.response.status
                                                          ? _c("p", [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Status:"
                                                                )
                                                              ]),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    log.response
                                                                      .status
                                                                  )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        log.response &&
                                                        log.response.result
                                                          ? _c("p", [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Result:"
                                                                )
                                                              ]),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    log.response
                                                                      .result
                                                                  )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        log.response &&
                                                        log.response.data
                                                          ? _c("p", [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Result:"
                                                                )
                                                              ]),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    log.response
                                                                      .data
                                                                  )
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                (log.response.error ||
                                                  log.response.message) &&
                                                log.type !== "media"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "block word-break"
                                                      },
                                                      [
                                                        log.response.error &&
                                                        log.response.error.Code
                                                          ? _c("p", [
                                                              _c("b", [
                                                                _vm._v("Code:")
                                                              ]),
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    log.response
                                                                      .error
                                                                      .Code
                                                                  )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        log.response &&
                                                        log.response.status
                                                          ? _c("p", [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Status:"
                                                                )
                                                              ]),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    log.response
                                                                      .status
                                                                  )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        log.response &&
                                                        log.response.statusText
                                                          ? _c("p", [
                                                              _c("b", [
                                                                _vm._v("Text:")
                                                              ]),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    log.response
                                                                      .statusText
                                                                  )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        log.response &&
                                                        log.response.message
                                                          ? _c("p", [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Message:"
                                                                )
                                                              ]),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    log.response
                                                                      .message
                                                                  )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        log.response.error &&
                                                        log.response.error
                                                          .Message
                                                          ? _c("p", [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Message:"
                                                                )
                                                              ]),
                                                              _vm._v(
                                                                _vm._s(
                                                                  log.response
                                                                    .error
                                                                    .Message
                                                                )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        log.response.error &&
                                                        log.response.error[
                                                          "InnerError"
                                                        ]
                                                          ? _c("p", [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "InnerError:"
                                                                )
                                                              ]),
                                                              _vm._v(
                                                                _vm._s(
                                                                  log.response
                                                                    .error[
                                                                    "InnerError"
                                                                  ].Message
                                                                )
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                log.type === "media"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "block word-break"
                                                      },
                                                      [
                                                        log.response &&
                                                        log.response.response &&
                                                        log.response.response
                                                          .status
                                                          ? _c("p", [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Status:"
                                                                )
                                                              ]),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    log.response
                                                                      .response
                                                                      .status
                                                                  )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        log.response &&
                                                        log.response.status
                                                          ? _c("p", [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Status:"
                                                                )
                                                              ]),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    log.response
                                                                      .status
                                                                  )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        log.response &&
                                                        log.response.data
                                                          ? _c("p", [
                                                              _c("b", [
                                                                _vm._v("Data:")
                                                              ]),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    log.response
                                                                      .data
                                                                  )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        log.response &&
                                                        log.response.message
                                                          ? _c("p", [
                                                              _c("b", [
                                                                _vm._v(
                                                                  "Message:"
                                                                )
                                                              ]),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    log.response
                                                                      .message
                                                                  )
                                                              )
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        log.response &&
                                                        log.response.statusText
                                                          ? _c("p", [
                                                              _c("b", [
                                                                _vm._v("Text:")
                                                              ]),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    log.response
                                                                      .statusText
                                                                  )
                                                              )
                                                            ])
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          i.name === "bridge"
                            ? _c(
                                "v-expansion-panel",
                                _vm._l(
                                  _vm.bridgeLogs.slice().reverse(),
                                  function(log) {
                                    return _c(
                                      "v-expansion-panel-content",
                                      {
                                        key: log.dynamicId,
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "header",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      class: [
                                                        {
                                                          "error-response":
                                                            log.error
                                                        },
                                                        {
                                                          "success-response":
                                                            log.response
                                                        }
                                                      ]
                                                    },
                                                    [
                                                      log && log.method
                                                        ? _c("p", [
                                                            _vm._v(
                                                              _vm._s(log.method)
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "10px"
                                                          }
                                                        },
                                                        [
                                                          _c("b", [
                                                            _vm._v(
                                                              "Request time:"
                                                            )
                                                          ]),
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                String(
                                                                  new Date(
                                                                    log.date
                                                                  ).getHours()
                                                                ).padStart(
                                                                  2,
                                                                  "0"
                                                                )
                                                              ) +
                                                              ":" +
                                                              _vm._s(
                                                                String(
                                                                  new Date(
                                                                    log.date
                                                                  ).getMinutes()
                                                                ).padStart(
                                                                  2,
                                                                  "0"
                                                                )
                                                              ) +
                                                              ":" +
                                                              _vm._s(
                                                                String(
                                                                  new Date(
                                                                    log.date
                                                                  ).getSeconds()
                                                                ).padStart(
                                                                  2,
                                                                  "0"
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        _c(
                                          "v-card",
                                          [
                                            log.error || log.response
                                              ? _c(
                                                  "v-card-text",
                                                  { staticClass: "word-break" },
                                                  [
                                                    _c("p", [
                                                      log.initiator
                                                        ? _c("b", [
                                                            _vm._v(
                                                              "Request sent by: "
                                                            )
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(log.initiator)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      log.params
                                                        ? _c("b", [
                                                            _vm._v("Params:")
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(
                                                        " " + _vm._s(log.params)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      log.data
                                                        ? _c("b", [
                                                            _vm._v("Data:")
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(
                                                        " " + _vm._s(log.data)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      log.error
                                                        ? _c("b", [
                                                            _vm._v("Message:")
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(
                                                        " " + _vm._s(log.error)
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          i.name === "console"
                            ? _c(
                                "v-card",
                                [
                                  _c("i", [
                                    _c("b", [
                                      _vm._v(
                                        "JavaScript Exception, Vue Exception and Vue Warn only"
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.consoleLogs.slice().reverse(),
                                    function(log, index) {
                                      return _c("v-card-text", { key: index }, [
                                        log.response && log.response.statusText
                                          ? _c("p", [
                                              _c("b", [_vm._v("Error type: ")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    log.response.statusText
                                                  )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        log.response &&
                                        log.response.data &&
                                        log.response.data.ExceptionType
                                          ? _c("p", [
                                              _c("b", [
                                                _vm._v("ExceptionType: ")
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    log.response.data
                                                      .ExceptionType
                                                  )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        log.response &&
                                        log.response.data &&
                                        log.response.data.Reference
                                          ? _c("p", [
                                              _c("b", [_vm._v("Reference: ")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    log.response.data.Reference
                                                  )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        log.response &&
                                        log.response.data &&
                                        log.response.data.Message
                                          ? _c("p", [
                                              _c("b", [_vm._v("Message: ")]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    log.response.data.Message
                                                  )
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "divider-wrapper" },
                                          [
                                            _c("div", {
                                              staticClass: "divider"
                                            })
                                          ]
                                        )
                                      ])
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          i.name === "media"
                            ? _c(
                                "v-card",
                                [
                                  _c("i", [
                                    _c("b", [
                                      _vm._v(
                                        "Configuration taken from window object in runtime"
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.mediaParams, function(
                                    param,
                                    index
                                  ) {
                                    return _c("v-card-text", { key: index }, [
                                      _c("p", [
                                        _c("b", [_vm._v(_vm._s(index) + ":")]),
                                        _vm._v(" " + _vm._s(param))
                                      ])
                                    ])
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          i.name === "storage"
                            ? _c("v-card", [
                                _c("i", [
                                  _c("b", [
                                    _vm._v("Local Storage and Session Storage")
                                  ])
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _c("h5", [_c("u", [_vm._v("Local Storage")])]),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  { staticClass: "word-break" },
                                  _vm._l(_vm.allLSkeys, function(item) {
                                    return _c("li", [
                                      _c("b", [_vm._v(_vm._s(item))]),
                                      _vm._v(
                                        " : " +
                                          _vm._s(_vm.localStorageData[item]) +
                                          "\n                "
                                      )
                                    ])
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c("h5", [
                                  _c("u", [_vm._v("Session Storage")])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  { staticClass: "word-break" },
                                  _vm._l(_vm.allSSkeys, function(item) {
                                    return _c("li", [
                                      _c("b", [_vm._v(_vm._s(item))]),
                                      _vm._v(
                                        " : " +
                                          _vm._s(_vm.sessionStorageData[item]) +
                                          "\n                "
                                      )
                                    ])
                                  }),
                                  0
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "btns-holder" }, [
              _vm.displayFilter && _vm.active === 0
                ? _c(
                    "div",
                    { staticClass: "filter-container" },
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        _vm._l(_vm.filterOptions, function(f, index) {
                          return _c("v-checkbox", {
                            key: index,
                            attrs: { color: "indigo", label: f, value: f },
                            model: {
                              value: _vm.selected,
                              callback: function($$v) {
                                _vm.selected = $$v
                              },
                              expression: "selected"
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "buttons" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { depressed: "", color: "normal" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_vm._v("Close")]
                  ),
                  _vm._v(" "),
                  _vm.active === 0
                    ? _c(
                        "v-btn",
                        {
                          attrs: { depressed: "", color: "error" },
                          on: {
                            click: function($event) {
                              return _vm.clear()
                            }
                          }
                        },
                        [_vm._v("Clear")]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64de7387", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64de7387","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utilities/logDialog.vue
// module id = null
// module chunks = 